import { makeStyles } from "@material-ui/core";
import { colors } from "shared/utils";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "16px",
  },
  titulo: {
    fontWeight: 600,
  },
  contador: {
    fontWeight: 600,
    color: colors.blueLighten,
  },
  root: {
    borderRadius: "19px",
    overflow: "hidden",
    minWidth: "500px",
    /* Con autoHeight el alto lo fijan las filas; este mínimo solo evita que el
     * estado vacío / el loader queden aplastados. */
    minHeight: "300px",
    "& .MuiDataGrid-iconButtonContainer": {
      display: "none",
    },
    "& .header": {
      background: colors.blueLighten,
      color: colors.white,
    },
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none",
    },
    "& .MuiDataGrid-cell": {
      textAlign: "center",
    },
    "& .MuiDataGrid-columnsContainer": {
      background: colors.blueLighten,
    },
  },
  acciones: {
    display: "flex",
    justifyContent: "flex-end",
  },
});

export default useStyles;
